<template>
  <div
    :class="['email-component', 'change-log-component', { selected: selected }]"
    :style="computedStyles"
    @click.stop="handleClick"
  >
    <div class="change-log-wrapper">
      <!-- Main Event Description -->
      <div class="change-log-header" :style="headerStyles">
        <div class="event-icon" :style="iconStyles">
          🔄
        </div>
        <div class="event-description" :style="descriptionStyles">
          Booking updated
        </div>
      </div>

      <!-- Changed By Section -->
      <div class="info-row" :style="infoRowStyles">
        <span class="info-label" :style="infoLabelStyles">Changed by:</span>
        <div class="user-info-inline" :style="userInfoInlineStyles">
          <div class="user-avatar-small" :style="avatarSmallStyles">
            👤
          </div>
          <span class="user-name-inline" :style="userNameInlineStyles">John Smith</span>
<!--          <span class="user-role-inline" :style="userRoleInlineStyles">(Manager)</span>-->
        </div>
      </div>

      <!-- Changed At Section -->
      <div class="info-row" :style="infoRowStyles">
        <span class="info-label" :style="infoLabelStyles">Changed at:</span>
        <span class="timestamp-inline" :style="timestampInlineStyles">
          January 15, 2025 at 2:30 PM
        </span>
      </div>

      <!-- Changes Details Section -->
      <div
        v-if="componentData.showAdditionalInfo"
        class="changes-section"
        :style="changesSectionStyles"
      >
        <div class="changes-label" :style="changesLabelStyles">
          Changes made:
        </div>
        <div class="changes-content" :style="changesContentStyles">
          Date changed from Jan 10 to Jan 15 • Time changed from 10:00 AM to 2:30 PM
        </div>
      </div>

      <!-- Booking Reference (if enabled) -->
      <div
        v-if="componentData.showBookingReference"
        class="booking-reference"
        :style="bookingRefStyles"
      >
        <span :style="refIconStyles">🔗</span>
        <span>Booking #12345</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeLogComponent',
  props: {
    componentData: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStyles() {
      const styles = this.componentData.styles || {}
      const backgroundColor = styles.backgroundColor === 'inherit' || !styles.backgroundColor ?
        'transparent' : styles.backgroundColor

      return {
        backgroundColor: backgroundColor,
        padding: `${styles.paddingTop || '20'}px ${styles.paddingRight || '20'}px ${styles.paddingBottom || '20'}px ${styles.paddingLeft || '20'}px`,
        marginTop: `${styles.marginTop || '16'}px`,
        marginBottom: `${styles.marginBottom || '16'}px`,
        borderRadius: `${styles.borderRadius || '8'}px`,
        border: styles.showBorder ? `1px solid ${styles.borderColor || '#e5e7eb'}` : 'none',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    headerStyles() {
      return {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '20px'
      }
    },

    iconStyles() {
      const styles = this.componentData.styles || {}
      return {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: styles.iconBackgroundColor || 'rgba(225, 78, 202, 0.1)',
        color: styles.iconColor || '#e14eca',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px',
        flexShrink: '0'
      }
    },

    descriptionStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.descriptionFontSize || '18'}px`,
        fontWeight: styles.descriptionFontWeight || '700',
        color: styles.descriptionColor || '#111827',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    infoRowStyles() {
      return {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px',
        flexWrap: 'wrap'
      }
    },

    infoLabelStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.labelFontSize || '14'}px`,
        fontWeight: '700',
        color: styles.labelColor || '#374151',
        fontFamily: styles.fontFamily || 'Arial, sans-serif',
        minWidth: 'fit-content'
      }
    },

    userInfoInlineStyles() {
      return {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }
    },

    avatarSmallStyles() {
      return {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: '#e5e7eb',
        color: '#9ca3af',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        flexShrink: '0'
      }
    },

    userNameInlineStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.userNameFontSize || '14'}px`,
        fontWeight: styles.userNameFontWeight || '600',
        color: styles.userNameColor || '#111827',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    userRoleInlineStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.userRoleFontSize || '14'}px`,
        color: styles.userRoleColor || '#6b7280',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    timestampInlineStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.timestampFontSize || '14'}px`,
        fontWeight: styles.timestampFontWeight || '600',
        color: styles.timestampColor || '#111827',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    changesSectionStyles() {
      const styles = this.componentData.styles || {}
      return {
        padding: '12px',
        backgroundColor: styles.changesSectionBackgroundColor || 'rgba(225, 78, 202, 0.05)',
        borderRadius: '6px',
        // borderLeft: `3px solid ${styles.changesAccentColor || '#e14eca'}`,
        marginBottom: '12px'
      }
    },

    changesLabelStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.changesLabelFontSize || '11'}px`,
        fontWeight: '600',
        color: styles.changesLabelColor || '#6b7280',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    changesContentStyles() {
      const styles = this.componentData.styles || {}
      return {
        fontSize: `${styles.changesContentFontSize || '13'}px`,
        color: styles.changesContentColor || '#374151',
        lineHeight: '1.5',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    bookingRefStyles() {
      const styles = this.componentData.styles || {}
      return {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: `${styles.bookingRefFontSize || '12'}px`,
        color: styles.bookingRefColor || '#6b7280',
        fontFamily: styles.fontFamily || 'Arial, sans-serif'
      }
    },

    refIconStyles() {
      const styles = this.componentData.styles || {}
      return {
        color: styles.bookingRefIconColor || '#9ca3af',
        fontSize: '14px'
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.change-log-component {
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  width: 100%;
  box-sizing: border-box;
}

.change-log-component:hover,
.change-log-component.selected {
  border-color: #e14eca !important;
  box-shadow: 0 0 0 4px rgba(225, 78, 202, 0.1);
}

.change-log-wrapper {
  width: 100%;
  position: relative;
}

.info-row {
  width: 100%;
}

.user-info-inline {
  display: flex;
  align-items: center;
}

/* Component Controls */
.component-controls {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 10;
}

.change-log-component.selected .component-controls {
  opacity: 1;
}

.control-btn {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 6px 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.control-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.delete-btn {
  color: #ef4444;
}

.delete-btn:hover {
  background: #fef2f2;
  border-color: #fecaca;
}

.control-btn i {
  font-size: 14px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .change-log-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 4px !important;
  }

  .user-info-inline {
    margin-left: 0 !important;
  }
}
</style>
